module.exports = __webpack_public_path__ + "static/rede-b0655554bf3c2205d01baa0e66dc8eb6.jpg";